import type { CommodityType, TypeOfCommodityType } from '../api/codebook/useGetCommodities';

export const commodityOptions: CommodityType[] = [
  { label: 'Feeder Cattle', value: 'FeederCattle' },
  { label: 'Swine', value: 'Swine' },
  { label: 'Fed Cattle', value: 'FedCattle' }
];

export interface LrpCommodityType {
  value: string;
  label: string;
  commodityId: 'FeederCattle' | 'FedCattle' | 'Swine';
  typeCode: string;
}

// prettier-ignore
const legacyCommodityTypes: LrpCommodityType[] = [
  { value: 'SteersWeight1', label: 'Steers Weight 1', commodityId: 'FeederCattle', typeCode: '809' },
  { value: 'SteersWeight2', label: 'Steers Weight 2', commodityId: 'FeederCattle', typeCode: '810' },
  { value: 'HeifersWeight1', label: 'Heifers Weight 1', commodityId: 'FeederCattle', typeCode: '811' },
  { value: 'HeifersWeight2', label: 'Heifers Weight 2', commodityId: 'FeederCattle', typeCode: '812' },
  { value: 'BrahmanWeight1', label: 'Brahman Weight 1', commodityId: 'FeederCattle', typeCode: '813' },
  { value: 'BrahmanWeight2', label: 'Brahman Weight 2', commodityId: 'FeederCattle', typeCode: '814' },
  { value: 'DairyWeight1', label: 'Dairy Weight 1', commodityId: 'FeederCattle', typeCode: '815' },
  { value: 'DairyWeight2', label: 'Dairy Weight 2', commodityId: 'FeederCattle', typeCode: '816' },
  { value: 'SteersHeifers', label: 'Steers & Heifers', commodityId: 'FedCattle', typeCode: '820' },
  { value: 'NoTypeSpecified', label: 'No Type Specified', commodityId: 'Swine', typeCode: '997' },
  { value: 'UnbornSwine', label: 'Unborn Swine', commodityId: 'Swine', typeCode: '821' },
  { value: 'UnbornSteersHeifers', label: 'Unborn Steers & Heifers', commodityId: 'FeederCattle', typeCode: '817' },
  { value: 'UnbornBrahman', label: 'Unborn Brahman', commodityId: 'FeederCattle', typeCode: '818' },
  { value: 'UnbornDairy', label: 'Unborn Dairy', commodityId: 'FeederCattle', typeCode: '819' },
  { value: 'AllTypes', label: 'All Types', commodityId: 'Swine', typeCode: '' }
];

// prettier-ignore
const ry2026CommodityTypes: LrpCommodityType[] = [
  { value: 'SteersWeight1', label: 'Steers Weight 1', commodityId: 'FeederCattle', typeCode: '809' },
  { value: 'SteersWeight2', label: 'Steers Weight 2', commodityId: 'FeederCattle', typeCode: '810' },
  { value: 'HeifersWeight1', label: 'Heifers Weight 1', commodityId: 'FeederCattle', typeCode: '811' },
  { value: 'HeifersWeight2', label: 'Heifers Weight 2', commodityId: 'FeederCattle', typeCode: '812' },
  { value: 'BrahmanWeight1', label: 'Brahman Weight 1', commodityId: 'FeederCattle', typeCode: '813' },
  { value: 'BrahmanWeight2', label: 'Brahman Weight 2', commodityId: 'FeederCattle', typeCode: '814' },
  { value: 'DairyWeight1', label: 'Dairy Weight 1', commodityId: 'FeederCattle', typeCode: '815' },
  { value: 'DairyWeight2', label: 'Dairy Weight 2', commodityId: 'FeederCattle', typeCode: '816' },
  { value: 'SteersHeifers', label: 'Steers & Heifers', commodityId: 'FedCattle', typeCode: '820' },
  { value: 'NoTypeSpecified', label: 'No Type Specified', commodityId: 'Swine', typeCode: '997' },
  { value: 'UnbornSwine', label: 'Unborn Swine', commodityId: 'Swine', typeCode: '821' },
  { value: 'UnbornSteersHeifers', label: 'Unborn Bulls & Heifers', commodityId: 'FeederCattle', typeCode: '817' },
  { value: 'UnbornBrahman', label: 'Unborn Brahman', commodityId: 'FeederCattle', typeCode: '818' },
  { value: 'UnbornDairy', label: 'Unborn Dairy', commodityId: 'FeederCattle', typeCode: '819' },
  { value: 'UnbornCalves', label: 'Unborn Calves', commodityId: 'FeederCattle', typeCode: '823' },
  { value: 'CullCows', label: 'Cull Cows', commodityId: 'FedCattle', typeCode: '821' },
  { value: 'AllTypes', label: 'All Types', commodityId: 'Swine', typeCode: '' }
];

// prettier-ignore
const ry2027CommodityTypes: LrpCommodityType[] = [
  { value: 'SteersWeight1', label: 'Steers Weight 1', commodityId: 'FeederCattle', typeCode: '809' },
  { value: 'SteersWeight2', label: 'Steers Weight 2', commodityId: 'FeederCattle', typeCode: '810' },
  { value: 'HeifersWeight1', label: 'Heifers Weight 1', commodityId: 'FeederCattle', typeCode: '811' },
  { value: 'HeifersWeight2', label: 'Heifers Weight 2', commodityId: 'FeederCattle', typeCode: '812' },
  { value: 'BrahmanWeight1', label: 'Brahman Weight 1', commodityId: 'FeederCattle', typeCode: '813' },
  { value: 'BrahmanWeight2', label: 'Brahman Weight 2', commodityId: 'FeederCattle', typeCode: '814' },
  { value: 'DairyWeight1', label: 'Dairy Weight 1', commodityId: 'FeederCattle', typeCode: '815' },
  { value: 'DairyWeight2', label: 'Dairy Weight 2', commodityId: 'FeederCattle', typeCode: '816' },
  { value: 'SteersHeifers', label: 'Steers & Heifers', commodityId: 'FedCattle', typeCode: '820' },
  { value: 'NoTypeSpecified', label: 'No Type Specified', commodityId: 'Swine', typeCode: '997' },
  { value: 'UnbornSwine', label: 'Unborn Swine', commodityId: 'Swine', typeCode: '821' },
  { value: 'UnbornSteersHeifers', label: 'Unborn Bulls & Heifers Weight 1', commodityId: 'FeederCattle', typeCode: '817' },
  { value: 'UnbornSteersHeifersWeight2', label: 'Unborn Bulls & Heifers Weight 2', commodityId: 'FeederCattle', typeCode: '820' },
  { value: 'UnbornBrahman', label: 'Unborn Brahman Weight 1', commodityId: 'FeederCattle', typeCode: '818' },
  { value: 'UnbornBrahmanWeight2', label: 'Unborn Brahman Weight 2', commodityId: 'FeederCattle', typeCode: '821' },
  { value: 'UnbornDairy', label: 'Unborn Dairy Weight 1', commodityId: 'FeederCattle', typeCode: '819' },
  { value: 'UnbornDairyWeight2', label: 'Unborn Dairy Weight 2', commodityId: 'FeederCattle', typeCode: '822' },
  { value: 'UnbornCalves', label: 'Unborn Calves', commodityId: 'FeederCattle', typeCode: '823' },
  { value: 'CullCows', label: 'Cull Cows', commodityId: 'FedCattle', typeCode: '821' },
  { value: 'AllTypes', label: 'All Types', commodityId: 'Swine', typeCode: '' }
];

export const commodityTypesByRY: Record<number, LrpCommodityType[]> = {
  2026: ry2026CommodityTypes,
  2027: ry2027CommodityTypes
};

// Each entry: any sales-effective date >= startsAt belongs to the given RY.
// Ordered newest-first so the first match wins.
const RY_CUTOFFS: readonly { startsAt: Date; ry: number }[] = [
  { startsAt: new Date('2026-07-01'), ry: 2027 },
  { startsAt: new Date('2025-07-01'), ry: 2026 }
];

export const getLrpCommodityTypesByDate = (date = new Date()): LrpCommodityType[] => {
  for (const cutoff of RY_CUTOFFS) {
    if (date >= cutoff.startsAt) return commodityTypesByRY[cutoff.ry];
  }
  return legacyCommodityTypes;
};

const resolveCommodityId = (commodity: string | number): LrpCommodityType['commodityId'] => {
  switch (commodity) {
    case 'FedCattle':
    case 802:
    case '802':
      return 'FedCattle';
    case 'Swine':
    case 815:
    case '815':
      return 'Swine';
    case 'FeederCattle':
    case 801:
    case '801':
    default:
      return 'FeederCattle';
  }
};

export const getLrpCommodityTypesForCommodityByDate = (
  commodity: string | number,
  date = new Date()
): LrpCommodityType[] =>
  getLrpCommodityTypesByDate(date).filter(t => t.commodityId === resolveCommodityId(commodity));

export const getCommodityTypeLabelByTypeCodeAndDate = (
  typeCode: string,
  commodity: string | number,
  date = new Date()
): string =>
  getLrpCommodityTypesForCommodityByDate(commodity, date).find(t => t.typeCode === typeCode)
    ?.label ?? '';

export const getCommodityTypeOptionsByDate = (date = new Date()): TypeOfCommodityType[] =>
  getLrpCommodityTypesByDate(date).map(({ value, label, commodityId }) => ({
    value,
    label,
    commodityId
  }));

export const getCommodityTypeLabelByDate = (commodityType: string, date = new Date()): string => {
  const list = getLrpCommodityTypesByDate(date);
  return list.find(x => x.value === commodityType)?.label ?? '';
};
